// Product Swiper Script

class ProductVideoSlider extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('.swiper');
    this.swiper = null;
  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {
    if (!this.slider) return;

    this.swiper = new Swiper(this.slider, {
      slidesPerView: 2.5,
      spaceBetween: 10,
      loop: true,
      speed: 500,

      breakpoints: {
        768: {
          slidesPerView: 3,
        }
      },

      on: {
        init: () => {
          this.handleVideoPlayback();
          this.bindVideoEnded();
        },

        slideChangeTransitionEnd: () => {
          this.handleVideoPlayback();
        }
      }
    });
  }

  bindVideoEnded() {
    const slides = this.querySelectorAll('.swiper-slide');
    slides.forEach((slide) => {
      const video = slide.querySelector('video');
      if (!video) return;
      video.addEventListener('ended', () => {
        this.swiper.slideNext();
      });
    });
  }

  handleVideoPlayback() {
    const slides = this.querySelectorAll('.swiper-slide');
    slides.forEach((slide) => {
      const video = slide.querySelector('video');
      if (!video) return;
      if (slide.closest('.swiper-slide').classList.contains('swiper-slide-active')) {
        video.play();
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }
}

customElements.define('product-video-slider', ProductVideoSlider);

/* product-videos.js */

(function () {
  'use strict';
 
  /* ── State ─────────────────────────────────────────────────── */
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  let videoData       = [];
  let TOTAL           = 0;
  let currentIndex    = 0;
  let isOpen          = false;
  let isMuted = isIOS ? true : false;
  let productsOpen    = false;
  let detailOpen      = false;
  let activeProduct   = null;
  let selectedVariant = null;
  let cartBusy        = false;
  let modalSwiper     = null;
 
  /* ── DOM Refs ──────────────────────────────────────────────── */
  const overlay            = document.getElementById('modalOverlay');
  const reelEl             = document.getElementById('videoReel');
  const closeBtn           = document.getElementById('closeBtn');
  const muteBtn            = document.getElementById('muteBtn');
  const prevBtn            = document.getElementById('prevBtn');
  const nextBtn            = document.getElementById('nextBtn');
  const progressBar        = document.getElementById('progressBar');
  const indexLabel         = document.getElementById('videoIndexLabel');
  const backdrop           = document.getElementById('modalBackdrop');
  const shareBtn           = document.getElementById('shareBtn');
  const shareOverlay       = document.getElementById('shareOverlay');
  const shareLink          = document.getElementById('shareLink');
  const shareX             = document.getElementById('shareX');
  const shareLinkedIn      = document.getElementById('shareLinkedIn');
  const shareFacebook      = document.getElementById('shareFacebook');
  const shareMessenger     = document.getElementById('shareMessenger');
  const shareWhatsApp      = document.getElementById('shareWhatsApp');
  const viewProductsBtn    = document.getElementById('viewProductsBtn');
  const productsPanel      = document.getElementById('productsPanel');
  const productsPanelBack  = document.getElementById('productsPanelBack');
  const productsGrid       = document.getElementById('productsGrid');
  const modalBottomCards   = document.getElementById('modalBottomCards');
  const productDetailPanel = document.getElementById('productDetailPanel');
  const detailPanelBack    = document.getElementById('detailPanelBack');
  const detailImages       = document.getElementById('detailImages');
  const detailBody         = document.getElementById('detailBody');
 
  let thumbCards = [];
 
  /* ── Progress bar ──────────────────────────────────────────── */
  let rafId = null;
 
  function startProgress(videoEl) {
    cancelAnimationFrame(rafId);
    (function tick() {
      if (!videoEl || !videoEl.duration) { progressBar.style.width = '0%'; return; }
      progressBar.style.width = ((videoEl.currentTime / videoEl.duration) * 100) + '%';
      rafId = requestAnimationFrame(tick);
    })();
  }
 
  function stopProgress() {
    cancelAnimationFrame(rafId);
  }
 
  /* ── Get video element by slide index ──────────────────────── */
  function getVideoEl(index) {
    if (!modalSwiper) return null;
    const slide = modalSwiper.slides[index];
    const v = slide ? slide.querySelector('.reel-video') : null;
    console.log('[VIDEO] getVideoEl(' + index + ') =', v ? 'FOUND src=' + v.src.slice(-30) : 'NULL');
    return v;
  }
 
  /* ── Play current slide video ──────────────────────────────── */
  function playCurrentVideo() {
    console.log('[VIDEO] playCurrentVideo() called, currentIndex=' + currentIndex);
    const videoEl = getVideoEl(currentIndex);
    if (!videoEl) { console.warn('[VIDEO] No videoEl found!'); return; }
 
    console.log('[VIDEO] videoEl.readyState=' + videoEl.readyState + ' networkState=' + videoEl.networkState + ' paused=' + videoEl.paused + ' src=' + videoEl.src.slice(-30));
 
    videoEl.muted = isMuted;
    videoEl.currentTime = 0;
 
    console.log('[VIDEO] Calling play() on slide ' + currentIndex);
    const p = videoEl.play();
    if (p !== undefined) {
      p.then(() => {
        console.log('[VIDEO] play() RESOLVED on slide ' + currentIndex);
        startProgress(videoEl);
        const wrap = document.getElementById('modalVideoWrap');
        if (wrap) wrap.classList.remove('is-paused');
      }).catch(err => {
        console.error('[VIDEO] play() REJECTED on slide ' + currentIndex + ':', err.name, err.message);
        stopProgress();
        const wrap = document.getElementById('modalVideoWrap');
        if (wrap) wrap.classList.add('is-paused');
      });
    } else {
      console.log('[VIDEO] play() returned undefined (old browser)');
    }
  }
 
  /* ── Pause all except current ──────────────────────────────── */
  function pauseAllExcept(exceptIndex) {
    if (!modalSwiper) return;
    modalSwiper.slides.forEach((slide, i) => {
      if (i === exceptIndex) return;
      const v = slide.querySelector('.reel-video');
      if (v) {
        console.log('[VIDEO] Pausing slide ' + i);
        v.pause();
        v.currentTime = 0;
      }
    });
  }
 
  /* ── Called after every slide transition ───────────────────── */
  function onSlideChange(index) {
    console.log('[SWIPER] onSlideChange -> index=' + index);
    stopProgress();
    currentIndex = index;
 
    indexLabel.textContent = (index + 1) + ' / ' + TOTAL;
    updateMuteIcon();
    updateNav();
    updateActiveThumbnail(index);
    renderBottomCards(index);
 
    if (viewProductsBtn) {
      viewProductsBtn.style.display =
        (videoData[index].products || []).length > 0 ? '' : 'none';
    }
 
    pauseAllExcept(index);
    playCurrentVideo();
  }
 
  /* ── Build vertical Swiper inside #videoReel ────────────────── */
  function buildModalSwiper() {
    reelEl.innerHTML = `
      <div class="swiper modal-reel-swiper" style="width:100%;height:100%;">
        <div class="swiper-wrapper">
          ${videoData.map((v, i) => `
            <div class="swiper-slide video-slide" data-index="${i}">
              <video
                class="reel-video"
                src="${v.videoUrl}"
                playsinline
                webkit-playsinline
                muted
                preload="metadata"
                loop
              ></video>
            </div>
          `).join('')}
        </div>
      </div>
    `;
 
    modalSwiper = new Swiper(reelEl.querySelector('.modal-reel-swiper'), {
      direction: 'vertical',
      slidesPerView: 1,
      loop: true,
      speed: 380,
      threshold: 10,
      resistanceRatio: 0,
      touchStartPreventDefault: false,
      on: {
        slideChangeTransitionEnd: function (swiper) {
          onSlideChange(swiper.activeIndex);
        }
      }
    });
 
    // Click-to-play / pause per slide
    modalSwiper.slides.forEach((slide, i) => {
      const videoEl = slide.querySelector('.reel-video');
      const toggle = () => {
        if (!videoEl) return;
        if (videoEl.paused) {
          videoEl.play().then(() => {
            slide.classList.add('playing');
            if (i === currentIndex) startProgress(videoEl);
          }).catch(() => {});
        } else {
          videoEl.pause();
          slide.classList.remove('playing');
          if (i === currentIndex) {
            stopProgress();
            const wrap = document.getElementById('modalVideoWrap');
            if (wrap) wrap.classList.add('is-paused');
          }
        }
      };
 
      slide.addEventListener('click', e => {
        if (e.target.closest('.modal-product-card')) return;
        if (e.target.closest('.card-cta')) return;
        toggle();
      });
 
      videoEl.addEventListener('play', () => {
        slide.classList.add('playing');
        if (i === currentIndex) {
          startProgress(videoEl);
          const wrap = document.getElementById('modalVideoWrap');
          if (wrap) wrap.classList.remove('is-paused');
        }
      });
 
      videoEl.addEventListener('pause', () => {
        slide.classList.remove('playing');
        if (i === currentIndex) {
          stopProgress();
          const wrap = document.getElementById('modalVideoWrap');
          if (wrap) wrap.classList.add('is-paused');
        }
      });
    });
  }
 
  /* ── Init ───────────────────────────────────────────────────── */
  function init() {
    try {
      const el = document.getElementById('videoProductsData');
      videoData = el ? JSON.parse(el.textContent) : [];
      TOTAL = videoData.length;
    } catch (e) {
      console.error('Failed to parse video data', e);
      return;
    }
 
    buildModalSwiper();
 
    thumbCards = Array.from(document.querySelectorAll('.thumb-card'));
    thumbCards.forEach(card => {
      card.addEventListener('click', () => {
        openModal(parseInt(card.dataset.index, 10));
      });
    });
 
    updateNav();
    attachShareLinks();
  }
 
  /* ── Open / Close modal ─────────────────────────────────────── */
  function openModal(index) {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    currentIndex = index;
    isOpen = true;
    overlay.classList.add('open');
 
    if (modalSwiper) modalSwiper.slideTo(index, 0, false);
    onSlideChange(index);
    attachShareLinks();
  }
 
  function closeModal() {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    isOpen = false;
    overlay.classList.remove('open');
    stopProgress();
    if (modalSwiper) {
      modalSwiper.slides.forEach(slide => {
        const v = slide.querySelector('.reel-video');
        if (v) { v.pause(); v.currentTime = 0; }
      });
    }
    progressBar.style.width = '0%';
    closeProductDetail();
    closeProductsPanel();
  }
 
  /* ── Navigation ─────────────────────────────────────────────── */
  function goNext() {
    if (modalSwiper && currentIndex < TOTAL - 1) modalSwiper.slideNext();
  }
  function goPrev() {
    if (modalSwiper && currentIndex > 0) modalSwiper.slidePrev();
  }
 
  /* ── UI helpers ─────────────────────────────────────────────── */
  function updateMuteIcon() {
    if (!muteBtn) return;
    const muteIcon   = muteBtn.querySelector('.mute');
    const unmuteIcon = muteBtn.querySelector('.unmute');
    if (muteIcon)   muteIcon.style.display   = isMuted ? 'none'  : 'block';
    if (unmuteIcon) unmuteIcon.style.display = isMuted ? 'block' : 'none';
  }
 
  function updateNav() {
    if (prevBtn) prevBtn.disabled = currentIndex === 0;
    if (nextBtn) nextBtn.disabled = currentIndex === TOTAL - 1;
  }
 
  function updateActiveThumbnail(index) {
    thumbCards.forEach((c, i) => c.classList.toggle('active', i === index));
  }
 
  /* ── Bottom product cards ───────────────────────────────────── */
  function renderBottomCards(index) {
    const products = (videoData[index] || {}).products || [];
    if (!products.length) { modalBottomCards.innerHTML = ''; return; }
 
    modalBottomCards.innerHTML = products.map((p, i) => `
      <div class="modal-product-card" data-product-index="${i}">
        <div class="card-thumb">
          <img src="${p.featured_image || ''}" alt="${p.title}">
        </div>
        <div class="card-info">
          <div class="card-name">${p.title}</div>
          <div class="card-price">${p.price}</div>
        </div>
        <button class="card-cta">Shop Now</button>
      </div>
    `).join('');
 
    modalBottomCards.querySelectorAll('.modal-product-card').forEach(card => {
      card.addEventListener('click', () => {
        openProductDetail(products[parseInt(card.dataset.productIndex, 10)]);
      });
    });
  }
 
  /* ── Products panel ─────────────────────────────────────────── */
  function openProductsPanel() {
    productsOpen = true;
    if (modalSwiper) modalSwiper.disable();
    renderProductGrid((videoData[currentIndex] || {}).products || []);
    productsPanel.classList.add('open');
  }
 
  function closeProductsPanel() {
    productsOpen = false;
    if (!detailOpen && modalSwiper) modalSwiper.enable();
    productsPanel.classList.remove('open');
  }
 
  function renderProductGrid(products) {
    if (!products.length) {
      productsGrid.innerHTML = '<p style="padding:24px;color:#8a8178;text-align:center;">No products for this video.</p>';
      return;
    }
    productsGrid.innerHTML = products.map((p, i) => `
      <div class="product-grid-card" data-product-index="${i}">
        <div class="product-grid-img">
          <img src="${p.featured_image || ''}" alt="${p.title}">
        </div>
        <div class="product-grid-name">${p.title}</div>
        <div class="product-grid-price">${p.price}</div>
        <button class="product-grid-shop-btn" data-product-index="${i}">SHOP NOW</button>
      </div>
    `).join('');
  }
 
  /* ── Product detail panel ───────────────────────────────────── */
  function openProductDetail(product) {
    activeProduct   = product;
    selectedVariant = ((product.variants || []).find(v => v.available) || product.variants[0]).id;
    detailOpen      = true;
    if (modalSwiper) modalSwiper.disable();
    renderDetailPanel(product);
    productDetailPanel.classList.add('open');
  }
 
  function closeProductDetail() {
    detailOpen    = false;
    activeProduct = null;
    if (!productsOpen && modalSwiper) modalSwiper.enable();
    productDetailPanel.classList.remove('open');
  }
 
  function renderDetailPanel(product) {
    const images = (product.images && product.images.length) ? product.images : [product.featured_image];
 
    detailImages.innerHTML = `
      <div class="detail-carousel" id="detailCarousel">
        ${images.map(src => `
          <div class="detail-carousel-slide">
            <img src="${src || ''}" alt="${product.title}">
          </div>
        `).join('')}
      </div>
      ${images.length > 1 ? `
        <button class="detail-carousel-arrow prev" id="detailCarouselPrev" aria-label="Previous image">
          <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <button class="detail-carousel-arrow next" id="detailCarouselNext" aria-label="Next image">
          <svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
        <div class="detail-carousel-dots" id="detailCarouselDots">
          ${images.map((_, i) => `<div class="detail-carousel-dot${i === 0 ? ' active' : ''}"></div>`).join('')}
        </div>
      ` : ''}
    `;
 
    if (images.length > 1) {
      const carousel = document.getElementById('detailCarousel');
      const prev     = document.getElementById('detailCarouselPrev');
      const next     = document.getElementById('detailCarouselNext');
      if (prev) prev.onclick = () => carousel.scrollBy({ left: -carousel.offsetWidth * 0.8, behavior: 'smooth' });
      if (next) next.onclick = () => carousel.scrollBy({ left:  carousel.offsetWidth * 0.8, behavior: 'smooth' });
      carousel.addEventListener('scroll', () => {
        const idx = Math.round(carousel.scrollLeft / (carousel.offsetWidth * 0.8));
        document.querySelectorAll('.detail-carousel-dot').forEach((d, i) => d.classList.toggle('active', i === idx));
      }, { passive: true });
    }
 
    const variantOptions = (product.variants || []).map(v =>
      `<option value="${v.id}"${!v.available ? ' disabled' : ''}>${v.title}${!v.available ? ' – Out of Stock' : ''}</option>`
    ).join('');
 
    detailBody.innerHTML = `
      <div class="detail-title">${product.title}</div>
      <div class="detail-price">${product.price}</div>
      <div class="detail-size-label">Select Size</div>
      <select class="detail-size-select" id="detailSizeSelect">${variantOptions}</select>
      <button class="detail-atc-btn" id="detailAtcBtn">Add to Cart</button>
      <div class="detail-accordion">
        <button class="detail-accordion-btn" id="detailAccordionBtn">
          Product details
          <svg viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"/></svg>
        </button>
        <div class="detail-accordion-body" id="detailAccordionBody">
          ${product.description || 'Premium quality product with exceptional design and comfort.'}
        </div>
      </div>
    `;
 
    const sizeSelect = document.getElementById('detailSizeSelect');
    sizeSelect.value = selectedVariant;
    sizeSelect.addEventListener('change', () => { selectedVariant = sizeSelect.value; });
    document.getElementById('detailAtcBtn').addEventListener('click', () => addToCart(selectedVariant));
    document.getElementById('detailAccordionBtn').addEventListener('click', function () {
      this.classList.toggle('open');
      document.getElementById('detailAccordionBody').classList.toggle('open');
    });
  }
 
  /* ── Add to cart ────────────────────────────────────────────── */
  async function addToCart(variantId) {
    if (cartBusy) return;
    cartBusy = true;
    const btn = document.getElementById('detailAtcBtn');
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error('cart');
      btn.textContent = 'Added to Cart!';
      setTimeout(() => { btn.textContent = original; btn.disabled = false; cartBusy = false; }, 2000);
    } catch {
      btn.textContent = original;
      btn.disabled = false;
      cartBusy = false;
    }
  }
 
  /* ── Share links ────────────────────────────────────────────── */
  function attachShareLinks() {
    if (!shareBtn) return;
    shareBtn.onclick = () => shareOverlay.classList.add('open');
    shareOverlay.onclick = e => { if (e.target === shareOverlay) shareOverlay.classList.remove('open'); };
 
    document.addEventListener('click', e => {
      if (e.target.closest('.share-close')) shareOverlay.classList.remove('open');
    });
 
    const url = window.location.href;
    shareLink.onclick = () => {
      navigator.clipboard.writeText(url).then(() => {
        const label = shareLink.querySelector('.share-label');
        const old = label.textContent;
        label.textContent = 'Copied!';
        setTimeout(() => label.textContent = old, 1500);
      });
    };
    shareX.href          = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`;
    shareLinkedIn.href   = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
    shareFacebook.href   = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    shareMessenger.href  = `fb-messenger://share/?link=${encodeURIComponent(url)}`;
    shareWhatsApp.href   = `https://wa.me/?text=${encodeURIComponent(url)}`;
  }
 
  /* ── Bootstrap ──────────────────────────────────────────────── */
  init();
 
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (backdrop) backdrop.addEventListener('click', closeModal);
 
  if (muteBtn) {
    muteBtn.addEventListener('click', () => {
      isMuted = !isMuted;
      if (modalSwiper) {
        modalSwiper.slides.forEach(slide => {
          const v = slide.querySelector('.reel-video');
          if (v) v.muted = isMuted;
        });
      }
      updateMuteIcon();
    });
  }
 
  if (prevBtn) prevBtn.addEventListener('click', goPrev);
  if (nextBtn) nextBtn.addEventListener('click', goNext);
 
  document.addEventListener('keydown', e => {
    if (!isOpen) return;
    if (e.key === 'Escape') {
      if (detailOpen)   { closeProductDetail(); return; }
      if (productsOpen) { closeProductsPanel(); return; }
      closeModal();
      return;
    }
    if (productsOpen || detailOpen) return;
    if (e.key === 'ArrowUp')   goPrev();
    if (e.key === 'ArrowDown') goNext();
  });
 
  if (viewProductsBtn)   viewProductsBtn.addEventListener('click', openProductsPanel);
  if (productsPanelBack) productsPanelBack.addEventListener('click', closeProductsPanel);
 
  if (productsGrid) {
    productsGrid.addEventListener('click', e => {
      const target = e.target.closest('[data-product-index]');
      if (!target) return;
      const products = (videoData[currentIndex] || {}).products || [];
      const p = products[parseInt(target.dataset.productIndex, 10)];
      if (p) openProductDetail(p);
    });
  }
 
  if (detailPanelBack) detailPanelBack.addEventListener('click', closeProductDetail);
 
})();
